// extracted by mini-css-extract-plugin
export default {"widget":"_2wc7q"};